import { userBrowser, objectToQueryString, objectToWindowFeaturesString } from '../utils/common';
import { AT_openBrWindow } from '../utils/athenaPopups';
import { getFullUrlPath } from '../utils/common';
import { dispatchAlert } from '../utils/site-utils';
import axios from 'axios';
import qs from 'qs';
import Label from '../utils/label';
import Config from '../utils/config';
 
var windowsHandle = new Array();
var _RES_BlockPopMsg = 'Window blocked! Please check "Block Pop-Up Windows" setting.';
function openWindowsHandle(typeID, winName, Condition, msg, url, winpara, callbackfunc) {
    if (Condition) {
        if (winpara == null) winpara = "";
        AT_openBrWindow(typeID, url, winName, winpara);
        if (callbackfunc != null) callbackfunc(windowsHandle[winName], isNewOpen);

    } else {
        dispatchAlert(msg);
        return;
    }
}

const GetUMStatus = (sportType, betType) => {
    return axios.post(getFullUrlPath('UM/GetUMStatus'), qs.stringify({sportType:sportType, betType:betType}));
}

export var NOpenKenoWindow = async function (lang, data, msg, msg2, RES_BlockPopMsg, actStatus) {
    let sportsType = "";
    
    switch(data.cust) {
        case "keno":
            sportsType = "202";
            break;
        case "kenolottery":
            sportsType = "220";
            break;
        case "tablegame":
            sportsType = "222";
            break;
        case "esports":
        case "egamer":
            sportsType = "43";
            break;
        case "sabaclub":
            sportsType = "200";
            break;
        case "vgaming":
            sportsType = "171";
            break;
        case "advantplay":
            sportsType = "172";
            break;
        case "soccerlottery":
        case "nslottery":
            sportsType ="169";
            break;
        case 'onerng-casino':
            sportsType = '208';
            break;
        case 'leapgaming':
            sportsType = '231';
            break;
        case 'maxgame':
            sportsType = '237';
            break;
        case "virtualgame":
            sportsType ="245";
            break;
        case "lucky3d":
            sportsType ="165";
            break;
    }
    const Result = await GetUMStatus(sportsType, "");
	if(Result) {
		if(Result.data && Result.data.IsUM) {
			dispatchAlert(Label.msg_3rdPartyUM_3);
            return;
        }
        else {
            _RES_BlockPopMsg = RES_BlockPopMsg ? RES_BlockPopMsg : _RES_BlockPopMsg;
            switch (data.cust) {
                case "advantplay":
                    if (data.isEnabled) {
                        OpenGamePage(data.windowName, data.windowName, actStatus, '', msg, msg2, data)
                    } else {
                        dispatchAlert(msg);
                    }
                    break;
                    
                case "keno":
                    openKenoGame(data.cust, lang, data.CanBetKeno, actStatus, msg2, data)
                    break;
                case "kenolottery":
                    openKenoGame(data.cust, lang, data.CanBetKenoLottery, actStatus, msg2, data)
                    break;
                case "esports":
                    if (data.EnableESportsWeb) {
                        OpenGamePage(26, 'esports', actStatus, '', msg, msg2, data)
                    }
                    break;
                case "tablegame":
                    openKenoGame(data.cust, lang, data.CanBetTableGame, actStatus, msg2, data)
                    break;
                case "egamer":
                    if (data.CanSeeEGamer) {
                        OpenGamePage(28, 'egamer', actStatus, '', msg, msg2, data)
                    }
                    break;
                case "sabaclub":
                    if (data.CanSeeSabaClub) {
                        OpenGamePage("sabaclub", 'sabaclub', actStatus, '', msg, msg2, data)
                    } else {
                        dispatchAlert(msg);
                    }
                    break;
                case "vgaming":
                    if (data.isEnabled) {
                        OpenGamePage(data.windowName, data.windowName, actStatus, '', msg, msg2, data)
                    } else {
                        dispatchAlert(msg);
                    }
                    break;
                case "soccerlottery":
                    if (data.CanSeeSportsLottery) {
                        OpenGamePage("soccerlottery", 'soccerlottery', actStatus, '', msg, msg2, data)
                    } else {
                        dispatchAlert(msg);
                    }
                    break;
                case "nslottery":
                    if (data.isEnabled) {
                        OpenGamePage(data.windowName, "nslottery", actStatus, '', msg, msg2, data)
                    } else {
                        dispatchAlert(msg);
                    }
                    break;
                case 'onerng-casino':
                    if (data.CanSeeCasino) {
                        OpenGamePage('OneRNGCasino', 'OneRNGCasino', actStatus, '', msg, msg2, data)
                    } else {
                        alert(msg);
                    }
                    break;
                case 'virtualgame':
                    if (data.CanSeeVirtualGame || data.CanSeeSportsMines || data.CanSeeSportsTowers) {
                        OpenGamePage(data.windowName, 'virtualgame', actStatus, '', msg, msg2, data)
                    } else {
                        alert(msg);
                    }
                    break;
                case 'leapgaming':
                    if (data.CanSeeLeapGaming) {
                        OpenGamePage('leapgaming', 'leapgaming', actStatus, '', msg, msg2, data)
                    } else {
                        alert(msg);
                    }
                    break;
                case 'maxgame':
                    if (data.CanSeeMaxGame) {
                        OpenGamePage('maxgame', 'maxgame', actStatus, '', msg, msg2, data)
                    } else {
                        alert(msg);
                    }
                    break;
                case 'lucky3d':
                    if (data.CanSeeLottoworld) {
                        OpenGamePage('lucky3d', 'lucky3d', actStatus, '', msg, msg2, data)
                    } else {
                        alert(msg);
                    }
                    break;
            }
        }
    }
}

function openKenoGame(gameName, lang, canBet, actStatus, msg, data){

    if (canBet) {
        OpenGamePage(gameName, gameName, actStatus, '', msg, msg, data)
    }else{        
        let pageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1115,height=768';
        openWindowsHandle(gameName, gameName, true, '', data.KenoURL, pageSetting)
    }
}

export var OpenExchange = function (actStatus) {
    if (actStatus == 2) {
        var PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1350,height=900';
        window.open('GamePage.aspx?game=Exchange', 'exchange', PageSetting);
    } else {
        dispatchAlert('Before you can experience the thrills of Exchange, please make a deposit into your account.');
    }
}

export function OpenGamePage(typeID, winName, Dep_ActStatus, refer, noneLoginMsg, noneDepositMsg, data) {
    var PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=679';
    var Condition = true;
    var referURL = "";
    var theURL = "";
    var msg = "";
    const allowNonDepositUserEnterGameList =['keno', 'kenolottery', 'tablegame', 'virtualgame', 'maxgame' , "esports", "lucky3d"]
    const isAllowEnter = (allowNonDepositUserEnterGameList.indexOf(winName) > -1)

    if ( Dep_ActStatus != "2" && !isAllowEnter) {
        winName = "CasinoAlert";
        Condition = false;
        msg = Dep_ActStatus == "0" ? noneLoginMsg : noneDepositMsg;
    }

    if (typeID === 'slot-game') {
        referURL = `&tab=slot&vdid=${data.vdid}`;
    }
    
    if (refer != undefined && refer != null)
    {
        referURL = "&refer=" + refer;
    }

    switch (winName) {
        case 'advantplay':
            PageSetting = data.windowPara;
            theURL = "GamePage.aspx?Game=" + referURL;
            break;
        case 'Casino':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "Casino_OpenCasino.aspx";
            break;
        case 'LiveCasino':
            theURL = "Casino_OpenLiveCasino.aspx";
            break;
        case 'CasinoAlert':
            theURL = "Casino_Alert.aspx";
            break;
        case 'OneRNGCasino':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        case 'esports':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1386,height=679';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        case 'egamer':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1386,height=679';
            theURL = "GamePage.aspx?Game=" + winName + ("&matchid=" + data.matchid) + (data.url ? "&url="+encodeURIComponent(data.url) : "") + referURL;
            break;
        case 'sabaclub':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        case 'soccerlottery':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=414,height=666';
            theURL = "GamePage.aspx?Game=" + winName + ("&timezone="+data.TimeZone) + referURL;
            break;
        case 'nslottery':
            PageSetting = data.windowPara;
            theURL = "GamePage.aspx?Game=" + winName + ("&gameid=" + data.betType) + ("&timezone="+data.TimeZone) + referURL;
            break;
        case 'keno':
        case 'kenolottery':
        case 'tablegame':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1115,height=768';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        case 'virtualgame':
            PageSetting = data.windowPara || 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "GamePage.aspx?Game=" + winName + (data ? ("&gameid=" + data.betType) + ("&timezone="+data.TimeZone) : "") + referURL;
            break;
        case 'leapgaming':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        case 'maxgame':
        case 'lucky3d':
            PageSetting = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=768';
            theURL = "GamePage.aspx?Game=" + winName + referURL;
            break;
        default:
            theURL = "GamePage.aspx?Game=" + winName + referURL;
    }
    if(data.betFrom && theURL.indexOf("betFrom") == -1){
        const indexOfQuestionMark = theURL.indexOf("?");
        if(indexOfQuestionMark != -1)
            theURL = `${theURL}${(indexOfQuestionMark == -1 ? "?" : "&")}betFrom=${data.betFrom}`;
    }
    openWindowsHandle(typeID, winName, Condition, msg, theURL, PageSetting);
}

export const OpenBonusPromo = function(title, type, tag) {
	let srcUrl = "";
    switch (type) {
        case '0':
            srcUrl = "./Bonus" + (tag && tag !== "" ? ("#" + tag) : "");
            break;
        case '1':
            srcUrl = "./Promotion";
            break;
        case '2':
            srcUrl = './SabaBonus/Promotion' + (tag && tag !== "" ? ("?planid=" + tag) : "");
            break;
        case '4':
            srcUrl = "./NewIndex/FreeBetRnR";
            break;
        case '5':
            srcUrl = './EuroCupOddsBoost';
            break;
        default:
            srcUrl = './SabaBonus/Promotion/exchange' + (tag && tag !== "" ? ("?planid=" + tag) : "");
            break;
    }
    const typeID = type === '0' ? 20 : type === '1' ? 22 : 24;
	const features = type === '0' ? 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=679' : 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=762,height=679';
	AT_openBrWindow(typeID, srcUrl, title, features);
};

export const OpenDepositPage = function(opentype, Title) {
	let wx = 1050,
		wy = 800;
	if(navigator.appVersion.indexOf('Chrome') > 0) {
		wx += 100;
	}
	let x = (screen.width - wx) / 2;
	let y = (screen.height - wy) / 2;
	x < 0 && (x = 0);
	y < 0 && (y = 0);
	const theURL = './NewIndex/Popup?Type=' + opentype;
	const features = 'left='+x+',top='+y+',width='+wx+',height='+wy+',location=no,resizable=no,scrollbars=yes';

	AT_openBrWindow(21, theURL, Title, features);
};

export function openPopup(queryObject = {}, title = '', size = {}) {
    const queryString = objectToQueryString(queryObject);
    const url = `./NewIndex/Popup?${queryString}`;
    let { wx, wy } = size;
    if (navigator.appVersion.indexOf('Chrome') > 0) {
		wx += 100;
    }
    
    let x = (screen.width - wx) / 2;
	let y = (screen.height - wy) / 2;
	x < 0 && (x = 0);
	y < 0 && (y = 0);
    const features = objectToWindowFeaturesString({
        left: x,
        top: y,
        width: wx,
        height: wy,
        location: 'no',
        resizable: 'no',
        scrollbars: 'yes'
    });
    AT_openBrWindow(21, url, title, features);
}


export function OpenAPIStatement(opentype, title = '', size = {}) {
    let url = "";
    switch (opentype) {
        case '4':
            url = 'EntryIndex/openSports?Link=B';
            break;
        case '5':
            url = 'EntryIndex/openSports?Link=S';
            break;
        case '6':
            url = 'EntryIndex/openSports?Link=R';
            break;
        default:
            url = '';
            break;
    }

    let { wx, wy } = size;
    if (navigator.appVersion.indexOf('Chrome') > 0) {
		wx += 100;
    }
    
    let x = (screen.width - wx) / 2;
	let y = (screen.height - wy) / 2;
	x < 0 && (x = 0);
	y < 0 && (y = 0);
    const features = objectToWindowFeaturesString({
        left: x,
        top: y,
        width: wx,
        height: wy,
        location: 'no',
        resizable: 'no',
        scrollbars: 'yes'
    });
    AT_openBrWindow(23, url, title, features);
}

export function IsThirdPartyPopup(type) {
    switch (type) {
        case 'advantplay':
        case 'keno':
        case "esports":
        case "egamer":
        case "sabaclub":
        case "vgaming":
        case "vgamingmobi":
        case "nslottery":
        case "virtualgame":
        case "leapgaming":
        case "maxgame":
        case "lucky3d":
            return true;
        default:
            return false;
    }
}

export function PopupThirdPartyDiv(type, para1, para2) {
    let lang = Config.appConfig.UserLang,
        msg = Label.lbl_PromptLoginDetail1,
        msg2 = Label.lbl_casino_alert,
        RES_BlockPopMsg = Label.lbl_BlockPopMsg,
        actStatus = Config.appConfig.ActStatus,
        data = {};
    switch (type) {
        case 'advantplay':
            data = {
                cust: type,
                isEnabled: Config.appConfig.CanSeeAdvantPlayVendorLobby,
                betFrom: para2.betFrom,
                windowName: "AdvantPlay",
                windowPara: 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1115,height=768'
            };
            break;
        case 'keno':
            data = JSON.parse(Config.appConfig.Keno);
            msg = Label.lbl_KenoNoDeposit;
            msg2 = Label.lbl_KenoFlashMsg;
            break;
        case "esports":
            data = {cust: type, EnableESportsWeb: Config.appConfig.EnableESportsWeb};
            break;
        case "egamer":
            data = {cust: type, CanSeeEGamer: Config.appConfig.CanSeeEGamer, matchid:para1, url:para2};
            break;
        case "sabaclub":
            data = {
                cust: type,
                CanSeeSabaClub: Config.appConfig.CanSeeSabaClub,
                betFrom: para2.betFrom
            };
            break;
        case "vgaming":
            data = {
                cust: type, 
                betFrom: para2.betFrom,
                isEnabled: !!para1 ? Config.appConfig.CanSeeVGamingMobi : Config.appConfig.CanSeeVGaming,
                windowName: !!para1 ? "VGamingMobi" : "VGaming"
            };
            break;
        case "nslottery":
            data = {
                cust: type,
                isEnabled: (Config.appConfig.CanSeeSportsLottery && Config.appConfig.SportsLotteryBetTypes.some(betType => betType == para2.betType)),
                TimeZone: para1,
                betType: para2.betType,
                betFrom: para2.betFrom,
                windowName: para2.windowName,
                windowPara: para2.windowPara
            };
            break;
        case "virtualgame":
            data = {
                cust: type, 
                CanSeeVirtualGame: Config.appConfig.CanSeeVirtualGame,
                CanSeeSportsMines: para2 ? (Config.appConfig.CanSeeSportsMines && 
                    Config.appConfig.SportsMinesBetTypes.some(betType => betType == para2.betType)) : false,
                CanSeeSportsTowers: para2 ? (Config.appConfig.CanSeeSportsTowers && 
                    Config.appConfig.SportsTowersBetTypes.some(betType => betType == para2.betType)) : false,
                TimeZone: para1 || "",
                betType: para2 ? para2.betType ? para2.betType : "" : "",
                windowName: para2 ? para2.windowName : type,
                windowPara: para2 ? para2.windowPara : "",
                betFrom: para2.betFrom
            };
            break;
        case "leapgaming":
            data = {
                cust: type,
                CanSeeLeapGaming: Config.appConfig.CanSeeLeapGaming,
                betFrom: para2.betFrom
            };
            break;
        case "maxgame":
            data = {
                cust: type,
                CanSeeMaxGame: Config.appConfig.CanSeeMaxGame,
                betFrom: para2.betFrom
            };
            break;
        case "lucky3d":
            data = {
                cust: type,
                CanSeeLottoworld: Config.appConfig.CanSeeLottoworld,
                betFrom: para2.betFrom
            };
            break;
    }
    NOpenKenoWindow(lang, data, msg, msg2, RES_BlockPopMsg, actStatus);
    return;
}